import { useMemo } from 'react';

import { JobQuoteVariant } from 'components/JobQuote';
import { useJobQuoteContext } from 'components/JobQuote/context';

import {
  ButtonWrapper,
  ButtonWrapperProps,
  DivWrapper,
  WrapperProps,
} from './Wrapper';

export interface JobQuoteHeaderHook {
  variant: JobQuoteVariant | undefined;
  Wrapper: React.FunctionComponent<WrapperProps>;
  wrapperProps: ButtonWrapperProps;
  tradingName: string;
  quoteReference: string;
  isLoading: boolean;
}

export default function useJobQuoteHeader(
  onClick?: () => void,
  open?: boolean,
): JobQuoteHeaderHook {
  const { variant, tradingName, quoteReference, isLoading } =
    useJobQuoteContext();

  const wrapper = useMemo(
    () => (!onClick ? DivWrapper : ButtonWrapper),
    [onClick],
  );

  const wrapperProps: ButtonWrapperProps = useMemo(
    () =>
      !onClick
        ? {}
        : {
            onClick,
            iconClassName: [
              'my-auto transition-all',
              open ? 'rotate-180' : 'rotate-0',
            ].join(' '),
          },
    [onClick, open],
  );

  return {
    variant,
    Wrapper: wrapper,
    wrapperProps,
    tradingName,
    quoteReference,
    isLoading,
  };
}
